import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const EmailTemplatesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/email-templates" */
    'routes/Control/Emails/TemplatesRoute'
  )
));

const UpdateEmailRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/update-email" */
    'routes/Emails/UpdateEmailRoute'
  )
));


const getControlEmailsRoutes = () => {
  return [
    {path: paths.getPathControlEmailTemplates(), component: EmailTemplatesRoute},
    {path: paths.getPathControlAddEmailTemplate(), render: (props) => <UpdateEmailRoute {...props} isTemplate={true} templateType={constants.EMAIL_TEMPLATE_TYPE_LIBRARY} />},
    {path: paths.getPathControlEditEmailTemplate(":templateId"), render: (props) => <UpdateEmailRoute {...props} isTemplate={true} templateType={constants.EMAIL_TEMPLATE_TYPE_LIBRARY} />},
    {path: paths.getPathControlReplicateEmailTemplate(":templateId"), render: (props) => <UpdateEmailRoute {...props} isTemplate={true} isReplicate={true} templateType={constants.EMAIL_TEMPLATE_TYPE_LIBRARY} />},
  ]
}



export { getControlEmailsRoutes };
